<template>
	<div class="page-wrapper">
		<div class="page-breadcrumb d-flex justify-content-between">
			<h2 class="page-title">Reputation</h2> 
		</div>
	</div>
</template>
<script>
export default {
  name: 'projectsReputation'
};
</script>
<style scoped lang="scss">

</style>
